<template>
  <div class="editor—wrapper">
    <!-- 工具栏 -->
    <div class="toolbar-container" ref="toolbar"></div>
    <!-- 编辑器 -->
    <div class="editor-container" ref="editor" @click='setFoucs'></div>
  </div>
</template>

<script>
import { createEditor, createToolbar } from '@wangeditor/editor'
import '@wangeditor/editor/dist/css/style.css'
export default {
  name: 'CustomEditor',
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    editorConfig: {
      type: Object
    }
  },
  data () {
    return {
      firstState: true
    }
  },
  computed: {
  },
  watch: {
    value (val) {
      this.editor.setHtml(val)
      // if (this.firstState) {
      //   // 首次放到最后
      //   this.editor.focus(true)
      //   this.firstState = false
      // }
    }
  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },
  beforeDestroy () {
    this.editor.destroy()
    this.toolbar && this.toolbar.destroy()
  },
  methods: {
    setFoucs () {
      this.editor && this.editor.focus()
    },
    getEditorConfig () {
      return {
        placeholder: '请输入',
        autoFocus: false,
        readOnly: this.readonly,
        onChange: editor => {
          // 未填数据初始化有数据
          if (editor.getHtml() !== '<p><br></p>') {
            this.$emit('input', editor.getHtml())
          }
        },
        MENU_CONF: {
          uploadImage: {
            server: this.$config.apiUrl + this.$apis.common.upload,
            fieldName: 'file',
            maxFileSize: 20 * 1024 * 1024, // 1M
            headers: { token: this.$store.state.token },
            customInsert: (res, insertFn) => {
              if (res.code === 200) {
                insertFn(res.data.filePrefix + res.data.fileUrl)
              } else {
                this.$message({ type: 'error', message: res.message })
              }
            }
          }
        },
        ...this.editorConfig // 加载外部的自定义配置
      }
    },
    init () {
      this.editor = createEditor({
        selector: this.$refs.editor,
        html: '',
        config: this.getEditorConfig(),
        mode: 'simple' // or 'simple'
      })

      if (!this.readonly) {
        this.toolbar = createToolbar({
          editor: this.editor,
          selector: this.$refs.toolbar,
          config: {
            excludeKeys: [
              'todo',
              'insertTable',
              'codeBlock',
              'undo',
              'redo',
              'fullScreen',
              'group-video',
              'insertImage',
              'insertLink',
              'bulletedList',
              'numberedList',
              'group-indent',
              'group-more-style',
              'divider',
              '|'
            ]
          },
          mode: 'default' // or 'simple'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.editor—wrapper {
  border: 1px solid #ccc;
  z-index: 1000; /* 按需定义 */
  width: 800px;
}
.toolbar-container {
  border-bottom: 1px solid #eee;
}
.editor-container {
  height: 460px;
}
</style>
